module.exports = __webpack_public_path__ + "img/landing-txt@2x.596acc93.png";